module.exports = __webpack_public_path__ + "img/angle-right.e7ef6128.svg";